// Waiting until DOM is loaded

document.addEventListener("DOMContentLoaded", function() {
  var form = document.querySelector('.eventregisterform form.jForm');

  if (form) {
      styliseForm(form);
  } else {

    var parent = document.querySelector(".eventregisterform form.jForm");

    if (parent) {
        // Set Callback function to be executed when observer find jForm loaded asynchronously
        var observer = new MutationObserver(function (mutations) {

            mutations.forEach(function (mutation) {

                for (var i = 0; i < mutation.addedNodes.length; i++) {
                    var node = mutation.addedNodes[i];

                    if (node.classList != undefined && node.classList.contains("jForm")) {

                        styliseForm(node);

                        observer.disconnect();
                    }
                }
            });
        });

        observer.observe(parent, {
            childList: true,
            subtree: true
        });
    }
  }
});

function addPhoneCodeSpan() {

  var phone = document.querySelector('.eventregisterform select[name="Phone[code]"]');
  var nodeinserting = document.querySelector(".eventregisterform .jForm__phone");

  //Create and insert phone value
  var div = document.createElement("span");
  div.id = "phone-value";
  nodeinserting.insertBefore(div, phone);
  document.querySelector("#phone-value").innerText = '(' + phone.value + ')';

  phone.addEventListener("input", function() {
    document.querySelector("#phone-value").innerText = phone.value
  });
}

function addLabelCountryResidence() {

  var countryResidence = document.querySelector('.eventregisterform .jForm .jForm__row select[name="Country"]').parentNode;

  if (!countryResidence.parentNode.querySelector('label')) {
	var label = document.createElement('label');
    label.classList.add('jForm__label');
    label.innerText = 'Country of residence'

    countryResidence.parentNode.insertBefore(label, countryResidence);
  }  
}

function validateEmail(event) {
  var target = event.target;
  var row = document.querySelector(".eventregisterform .jForm__row .jForm__input[name='Email'").parentNode.parentNode;
  var error = target.parentElement.querySelector('.errormsg');

  var mailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (target.value.match(mailformat)) {
    row.classList.remove('jForm_invalid');
    error.classList.remove('showError');
  } else {
    row.classList.add('jForm_invalid');
    error.classList.add('showError');

  }

}

function createEmailErrorMsg() {
  var field = document.querySelector(".eventregisterform .jForm__input[name='Email']").parentNode;
  var errormsg = document.createElement('span');
  errormsg.classList.add('errormsg');
  errormsg.innerText = 'Invalid email';
  field.appendChild(errormsg);
}

function recalculatePositionTelLabel() {
  var tlfNumberField = document.querySelector('.jForm__input[name="Phone[value]"]');
  var tlfNumberLabel = tlfNumberField.parentNode.parentNode.firstElementChild;

  tlfNumberLabel.style.right = tlfNumberField.offsetWidth - tlfNumberLabel.offsetWidth + 'px';
}

function styliseForm(node) {
  var form = node;
  // var form = document.querySelector('.eventregisterform form.jForm');
    var inputs = form.querySelectorAll("input.jForm__input");
    var tlfNumberField = document.querySelector('.jForm__input[name="Phone[value]"]');
    var tlfNumberLabel = tlfNumberField.parentNode.parentNode.firstElementChild;

  window.addEventListener('resize', recalculatePositionTelLabel);

  addPhoneCodeSpan();

  addLabelCountryResidence()

  //Add event listener for all inputs
  for (var j = 0; j < inputs.length; j++) {
    var input = inputs[j];

    input.addEventListener('focus', function(e) {

      var animationTarget = e.target.parentElement.parentElement;

      // On focus animation while filling input
      e.target.parentElement.parentElement.classList.add('input-focus');
      if (e.target.name == 'Phone[code]') {
        return
      };
      if (e.target.name == 'Phone[value]') {
        tlfNumberLabel.style.transform = 'scale(.75)';
      };
      animationTarget.classList.add('active');
      animationTarget.classList.add('active-label');

    })

    input.addEventListener('blur', function(e) {

      var animationTarget = e.target.parentElement.parentElement;

      // On blur animation leaving the input
      animationTarget.classList.remove('input-focus');
      animationTarget.classList.remove('active-label');
      if (e.target.value == null || e.target.value == "") {
        e.target.parentElement.parentElement.classList.remove('active');
        tlfNumberLabel.style.transform = 'translateY(16px) scale(1)';
        return;
      }
      animationTarget.classList.remove('jForm_invalid');
    });
  };

  form.addEventListener('submit', function(e) {

    var inputsArray = Array.from(inputs);

    var filteredInputs = inputsArray.filter(function(input) {
      return input.value == "" || input.value == null
    });

    if (filteredInputs.length > 0) {

      var scroll = inputs[0].getBoundingClientRect().top + window.scrollY - inputs[0].offsetHeight - 10;
      window.scrollTo({
        top: scroll,
        behavior: 'smooth'
      });
    }

    filteredInputs.forEach(function(input) {
      input.parentElement.parentElement.classList.add('jForm_invalid');
      input.parentElement.parentElement.classList.add('jForm__invalid');
    });
  });

  createEmailErrorMsg();

  var email = form.querySelector(".eventregisterform .jForm__input[name='Email']");

  email.addEventListener("blur", validateEmail);
}